import { makeLMStyles } from "@launchmetrics/lm-ui";

type StyleProps = {
    selected: boolean
}

export const useStyles = makeLMStyles((props?: StyleProps) => ({
	row: {
		position: 'relative',
		backgroundColor: props?.selected ? 'surface.neutralSubtle.hover' : 'none',
		':hover': {
			'td:last-of-type': {
				button: {
					visibility: 'visible'
				}
			}
		}
	},
	reportName: {
		textDecoration: 'underline',
		cursor: 'pointer',
		':hover': {
			color: 'text.primary'
		}
	},
	reportTypeContainer: {
		display: 'flex',
		alignItems: 'center',
		svg: {
			marginRight: 'spacing-8'
		}
	},
	deleteIconContainer: {
		paddingY: 'spacing-6',
		button: {
			visibility: 'hidden'
		}
	},
	deleteIcon: {
		color: 'icon.danger'
	}
}));